module.exports = __webpack_public_path__ + "img/Payment Portal.c74adb08.jpeg";